import { render, staticRenderFns } from "./add.vue?vue&type=template&id=615db77b&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.6_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._v3ikegxpyohwicxz2xngozg43i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615db77b",
  null
  
)

export default component.exports